import React from 'react';
import { motion } from 'framer-motion';

export const SiteIllustration = ({ type = "structure" }) => {
  return (
    <div className="relative w-full h-48 bg-slate-900/50 rounded-sm overflow-hidden border border-slate-800/50">
      {/* Blueprint Grid Background */}
      <div className="absolute inset-0 bg-blueprint opacity-20"></div>
      
      <div className="absolute inset-0 flex items-center justify-center">
        {type === "structure" && (
          <svg viewBox="0 0 200 120" className="w-full h-full p-8 opacity-40">
            {/* Structural Wireframe */}
            <g stroke="currentColor" fill="none" strokeWidth="0.5" className="text-cyan-500">
              <path d="M20 100 L180 100 L160 40 L40 40 Z" />
              <path d="M60 40 L60 100" />
              <path d="M100 40 L100 100" />
              <path d="M140 40 L140 100" />
              <path d="M40 70 L160 70" />
              {/* Crane Hook */}
              <motion.path 
                animate={{ x: [0, 20, 0] }}
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                d="M100 10 L100 40 M95 35 L105 35" 
                strokeWidth="2"
              />
            </g>
          </svg>
        )}
        
        {type === "manpower" && (
          <div className="flex gap-4 items-end h-24">
            {[40, 70, 55, 90, 65].map((h, i) => (
              <motion.div
                key={i}
                initial={{ height: 0 }}
                animate={{ height: `${h}%` }}
                className="w-8 bg-gradient-to-t from-cyan-600/20 to-cyan-400/40 border-t border-cyan-400"
              />
            ))}
          </div>
        )}
      </div>
      
      {/* Overlay Scanline */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-cyan-500/5 to-transparent h-1/2 w-full animate-scan"></div>
    </div>
  );
};